export default  {
    bindings: {
        property: '<',
        formTab: '=',
        type: '@'
    },
    controller: 'propertyDetailsController',
    template: require('../views/property.social.html')
};



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/property/components/property.social.component.js